import { render, staticRenderFns } from "./PrivacySecurity.vue?vue&type=template&id=289fef78"
import script from "./PrivacySecurity.vue?vue&type=script&lang=js"
export * from "./PrivacySecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports